export default "/barricade.glb";